import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@repo/ui";
import { Alert, AlertDescription } from "@repo/ui";
import { StardeckSignInButton, useAuth } from "@stardeck-customer-apps/project-auth";
import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function Login() {
  const { user, isLoading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState("");

  const returnTo = searchParams.get("returnTo") || "/admin";
  const errorParam = searchParams.get("error");

  useEffect(() => {
    if (user && !authLoading) {
      navigate(returnTo, { replace: true });
    }
  }, [user, authLoading, navigate, returnTo]);

  if (authLoading) {
    return (
      <div className="min-h-dvh grid place-items-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (user) {
    return null;
  }

  const errorMessage = errorParam || error;

  return (
    <div className="min-h-dvh grid place-items-center px-6 py-20 bg-[radial-gradient(60%_80%_at_50%_0%,_#ffffff_0%,_#eef2f7_100%)]">
      <div className="w-full max-w-sm">
        <Card>
          <CardHeader className="text-center">
            <CardTitle>Sign in</CardTitle>
            <CardDescription>Access the admin area</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            {errorMessage && (
              <Alert variant="destructive">
                <AlertDescription>{errorMessage}</AlertDescription>
              </Alert>
            )}
            <StardeckSignInButton
              style={{ width: "100%" }}
              onSuccess={() => navigate(returnTo, { replace: true })}
              onError={(err) => setError(err.message)}
            />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
